// Mirrors estating-api services/family-user-role-service.ts
const DOMAIN_REGEX = /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)+$/;

export const normalizeDomain = (domain: string) => domain.trim().toLowerCase().replace(/^@+/, '');

export const isValidDomain = (domain: string) => DOMAIN_REGEX.test(normalizeDomain(domain));

// Empty list allows any email. 'sub.estating.com' matches 'estating.com', 'notestating.com' does not.
export const emailMatchesDomains = (email?: string, domains?: string[]) => {
  if (!domains || domains.length === 0) return true;
  const host = (email ?? '').trim().toLowerCase().split('@')[1];
  if (!host) return false;
  return domains.some((d) => host === d || host.endsWith(`.${d}`));
};
